<style lang="scss" scoped></style>

<template>
  <div class="container">
    <HeaderTop></HeaderTop>
    <Header></Header>
    <router-view></router-view>
    <!-- <Footer></Footer> -->
      <RightSide></RightSide>
  </div>
</template>

<script>
import HeaderTop from "@/components/base/headerTop.vue";
import Header from "@/components/base/header";
import Footer from "@/components/base/footer";
import RightSide from "@/components/base/rightSide";
export default {
  components: {
    Header,
    Footer,
    HeaderTop,
      RightSide,
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  computed: {},
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
  width: 100%;
  min-width: 1200px;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 200px;
  // padding-top: 100px;
}
</style>
